import * as React from 'react';
// removed import of scss-style
const Loader = () => (React.createElement("div", { className: 'Loader Loader' },
    React.createElement("div", { className: 'Loader__gfxHolder' },
        React.createElement("div", { className: 'Loader__gfx' }),
        React.createElement("div", { className: 'Loader__gfx' }),
        React.createElement("div", { className: 'Loader__gfx' }))));
export default Loader;
